import {Component, Injector, OnInit, Pipe, PipeTransform} from '@angular/core';
import {BaseAdminPanelComponent} from "../../base-admin-panel/base-admin-panel.component";
import {Observable} from "rxjs";
import {RouteViewModel, StopViewModel} from "../Model/RouteViewModel";
import {CreateRoutesComponent} from "../create-routes.component";
import {GeozoneViewModel} from "../../Geozone/Model/GeozoneViewModel";
import {EditRoutesComponent} from "../edit-routes.component";
import {RoutesService} from "../../../../services/routes.service";
import {ZoneService} from "../../../../services/zones.service";

@Pipe({
    name: 'zoneOrder',
    pure: false,
    standalone: false
})
export class ZoneOrderPipe implements PipeTransform {
  transform(array: StopViewModel[]): any {
    var items = [];
    for (var i = 0; i < array.length; i++)
      items.push(array[i]);

    items.sort((a: StopViewModel, b: StopViewModel) => {
      if (a.Order < b.Order)  return -1;
      else
        if (a.Order > b.Order)  return 1;
        else                    return 0;
    });
    return items;
  }
}

@Component({
    selector: '[app-routes]',
    templateUrl: './routes.component.html',
    styleUrls: ['./routes.component.css'],
    standalone: false
})
export class RoutesComponent extends BaseAdminPanelComponent implements OnInit {
  private routesService: RoutesService;
  private zonesService: ZoneService;

  constructor( protected injector: Injector) {
    super(injector);
    this.routesService = injector.get(RoutesService);
    this.zonesService = injector.get(ZoneService);
  }

  public zones: GeozoneViewModel[] = [];

  ngOnInit() {
    super.ngOnInit();
    this.Refresh();
    this.zonesService.GetZones()
      .subscribe(zones => {
      this.zones = zones;
    });
  }

  protected Refresh() {
   this.routesService.GetRoutes()
     .subscribe(drivers => {
      this.objects = drivers;
    });
  }

  protected doDeleteObject(id: number): Observable<any> {
    return this.routesService.DeleteRoute(id);
  }

  public openCreateModal() {
    this.prepareModal(CreateRoutesComponent);

    let objectCreateViewModel = new RouteViewModel();
    this.componentRef.instance.zones = this.zones;
    this.componentRef.instance.open(objectCreateViewModel);
  }

  public openEditModal(object: RouteViewModel) {

    this.prepareModal(EditRoutesComponent);
    this.componentRef.instance.zones = this.zones;
    this.componentRef.instance.open(object);
  }
}
